import { useRef, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from 'react-redux';
import PageTitle from "../../../components/partials/PageTitle";
import { useSelector } from "react-redux/es/exports";
import { useEffect } from "react";
import {
  fetchAllUsers, searchUsers,
} from "./../../../redux/slice/user/userSlice";
import { resetUsers } from './../../../redux/slice/user/userSlice';
import { Link, useNavigate } from 'react-router-dom';
import PaginationLinks from '../../../components/pagination/PaginationLinks';
import { CSVLink } from 'react-csv';
import pdf from "../../../assets/images/img-icons/pdf.png";
import excel from "../../../assets/images/img-icons/excel.png";
import { useReactToPrint } from 'react-to-print';
import { BounceLoader } from "react-spinners";

const AllUser = () => {
  const [filterBy, setFilterBy] = useState()
  const [hasAddUser, setHasAddUser] = useState()
  const [hasViewUser, setHasViewUser] = useState()
  const [pageNumber, setPageNumber] = useState(1);
  const { all_users, searchLoading } = useSelector((state) => state?.user);
  const { isSuccess } = useSelector(state => state?.user)
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const { user } = useSelector((state) => state?.auth?.user);
  const [currentUsers, setCurrentUsers] = useState([]);

  const pdfRef = useRef()

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const generatePDF = useReactToPrint({
    content: () => pdfRef.current,
    documentTitle: "All Users",
  });

  // const exportXlsxData = () => {
  //   const itemsWithValues = {};
  //   return all_users?.data?.map((item) => {
  //   for (const key in item) {
  //       if (item[key]) {
  //       let keyChange = key?.split("_")?.join(" ");
  //       itemsWithValues[keyChange] = item[key];
  //       }
  //   }
  //   return itemsWithValues;
  //   });
  // };

  // breadcrumb
  const breadcrumb = {
    from: {
      title: "User",
      link: "/admin/all-users",
    },
    current: {
      title: "list",
      link: null,
    },
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterBy.length) {
      const payload = {
        office_id: user?.office_id,
        searchText: filterBy
      }
      dispatch(searchUsers(payload))
    }
  } 

  // fetch staff list on click of pagination links
  const fetchUsersHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(fetchAllUsers(pageNum));
  };

  useEffect(() => {
    if (all_users) {
      setCurrentUsers(all_users);
    }
    }, [all_users]);

  useEffect(() => {
    if (!filterBy) {
      dispatch(fetchAllUsers(`${pageNumber}`));
    }
    // dispatch(logState())

  }, [dispatch, filterBy, pageNumber]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetUsers())
      return;
    }

  }, [dispatch, isSuccess]);
  

  useEffect(() => {
    if (!user_permissions?.some(permission => permission.name === 'user module')) {
      navigate('/admin/dashboard')
    }

    setHasAddUser(user_permissions?.some(permission => permission.name === 'add user'))
    setHasViewUser(user_permissions?.some(permission => permission.name === 'view user details'))
  }, [navigate, user_permissions])


  return (
    <>
      {/* page title */}
      <PageTitle title='Available Users' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* Table row */}
      
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
          <div className='mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0'>
            <div className={`d-flex ${hasAddUser ? 'justify-content-between' : 'justify-content-end'} align-items-center`}>
              {hasAddUser && <div>
                <Link
                    className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3'
                    style={{ height: "30px", padding: "10px 10px" }}
                    to='/admin/add-user'
                >
                    <span>
                        <i className='mdi mdi-plus fs-4'></i>
                    </span>
                    <span  
                        className='text-dark pe-2 text-white'
                    >
                        Add User
                    </span>
                </Link>
              </div>}
              <div className='d-flex justify-content-between align-items-center gap-3'>
                <form
                  onSubmit={handleSearch}
                  className='d-flex bg-primary-1 align-items-center '
                  style={{ height: "30px", width: "217px" }}
                >
                  <input
                    type='search'
                    value={filterBy}
                    className='border-0'
                    placeholder='Search...'
                    onChange={(e) => setFilterBy(e.target.value)}
                    style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                  />
                  <button
                    type='submit'
                    className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                    style={{ height: "28px" }}
                  >
                    <i className='uil uil-search text-white fs-4'></i>
                  </button>
                </form>
                <div className=' d-flex align-items-center border '>
                  <span
                    className='bg-info me-2 text-white'
                    style={{ padding: "3px" }}
                  >
                    Export to
                  </span>

                  <span
                    href='#'
                    id='btnExport'
                    className='me-1'
                    title='Export to Pdf'
                    onClick={generatePDF}
                  >
                    <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
                  </span>

                  {/* <CSVLink
                    data={exportXlsxData()}
                    style={{ fontWeight: "bolder" }}
                    filename='Available Users'
                  >
                    <span
                      href='#'
                      id='btnExport'
                      className='mr-1'
                      title='Export to Excel'
                    >
                      <img
                        src={excel}
                        alt='export-excel'
                        style={{ height: "20px", marginRight: "5px" }}
                      />
                    </span>
                  </CSVLink> */}
                </div>
              </div>
            </div>
          </div>
          <div className=''>
            <div className='col-12 position-relative'>
              <div className='row'>
                <div className='col-sm-12'>
                  {currentUsers.data?.length < 1 ? (
                    <h5 className='alert alert-info'>Result not found!</h5>
                  ) : (
                    <>
                      <div className='table-responsive' ref={pdfRef}>
                        <table className='table table-centered table-striped nowrap w-100 no-footer'>
                          <thead>
                            <tr>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "147.8px" }}
                                aria-label='Email: activate to sort column ascending'
                              >
                                Staff Id
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "120.8px" }}
                                aria-label='Customer: activate to sort column ascending'
                              >
                                Status
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "144.8px" }}
                                aria-label='Phone: activate to sort column ascending'
                              >
                                First name
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "144.8px" }}
                                aria-label='Phone: activate to sort column ascending'
                              >
                                Last name
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "156.8px" }}
                                aria-label='Location: activate to sort column ascending'
                              >
                                Office
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "156.8px" }}
                                aria-label='Location: activate to sort column ascending'
                              >
                                Role
                              </th>
                              <th
                                className='sorting'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "120.8px" }}
                                aria-label='Status: activate to sort column ascending'
                              >
                                Locked
                              </th>
                              {hasViewUser && <th style={{ width: "105.8px" }}>Action</th>}
                            </tr>
                          </thead>

                          <tbody>
                          {currentUsers?.data?.map((data) => ( 
                            <tr key={data.id}>
                              <td className='text-dark'>
                                {data.staff_id}
                              </td>
                              <td>
                                <span
                                  className={`badge badge-${
                                    data.status === 0
                                      ? "danger"
                                      : "success"
                                  }-lighten fw-normal rounded-4`}
                                  style={{
                                    fontSize: "10px",
                                    padding: "5px 18px",
                                  }}
                                >
                                  {data.status === 0
                                    ? "disabled"
                                    : "active"}
                                </span>
                              </td>
                              <td className='table-user'>
                                <span
                                  className='text-body fw-semibold'
                                >
                                  {data.first_name}
                                </span>
                              </td>                                      
                              <td className='table-user'>
                                <span
                                  className='text-body fw-semibold'
                                >
                                  {data.last_name}
                                </span>
                              </td>                                      
                              <td>{data?.office_user?.office_name}</td>
                              <td>{data?.roles?.map((item, index) =>(
                                <span key={item.id}>
                                    {index < 1 && <>{item.name}</>}
                                    {index < data.roles.length - 1 && index < 1 && <>,</>}
                                    {index === 1 && <>{item.name}...</>}
                                </span>
                              ))}
                              </td>
                              <td>{data.locked === 0
                                    ? "No"
                                    : "Yes"}
                              </td>
                              {hasViewUser && <td className='text-body'>
                                <Link
                                  to={`/admin/user/user-profile/${data?.id}`}
                                  state={{ staff_id: data?.id }}
                                >
                                  <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                                </Link>
                              </td>}
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                      <div className='row mt-2'>
                        <div className='col-sm-12 col-md-6'>
                          <div
                            className='dataTables_info table-pages'
                            id='products-datatable_info'
                            role='status'
                            aria-live='polite'
                          >
                            Showing users {currentUsers?.from} to{" "}
                            {currentUsers?.to} of {currentUsers?.total}
                          </div>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                          <PaginationLinks
                            paginationData={currentUsers}
                            getNextPage={fetchUsersHandler}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {(searchLoading) && (
                    <div
                      className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                      style={{ height: "100%" }}
                    >
                      <div className='mx-auto'>
                        <BounceLoader
                          color='#090b8f'
                          loading={true}
                          // cssOverride={override}
                          size={50}
                          aria-label='Loading Spinner'
                          data-testid='loader'
                          className='ms-3'
                        />
                        <span className='fw-bolder text-primary-1 ms-2'>
                          Please wait...
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
      </div>
    </>
  );
};

export default AllUser